
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSoundUnavailable as ObiSoundUnavailableElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sound-unavailable.js';
 
 
 

 
 export const ObiSoundUnavailable = createComponent({
   react: React,
   tagName: 'obi-sound-unavailable',
   elementClass: ObiSoundUnavailableElement,
   events: {
     
   }
  });
 
 